<template>
  <span ref="countUpRef" class="count-up" />
</template>
<script lang="ts" setup>
import CountUp  from '@/utils/countup.js';
import { useLazyLoad } from '@/directives/lazy-load';

const props = defineProps({
  duration: {
    type: Number,
    default: 1.9
  },
  data: {
    type: [Number, String],
    default: 0
  },
  separator: {
    type: Boolean,
    default: true
  },
  repeat: {
    type: Boolean,
    default: true
  }
});

const countUpRef = ref();

const setCountUp = (v: string|number, duration = 0) => {
  let value = Number(`${v}`.replaceAll(',', ''));
  if (value && !isNaN(value)) {
    const options = { duration: duration || props.duration || 2 };
    options.separator = props.separator ? ',' : '';
    setTimeout(() => { // 异步 等待ref挂载
      new CountUp(countUpRef.value, value, options).start();
    }, 0);
  }
};
watch(() => props.data, v => {
  setCountUp(v, 0.3);
});

const isIntersecting = useLazyLoad(countUpRef, { threshold: 0.1 });
watch(isIntersecting, visible => {
  if (visible && props.repeat) {
    setCountUp(props.data);
  }
});
</script>
<style lang="scss" scoped>

</style>
